console.log("Loaded");

window.onscroll = getScrollPosition;

scrollObject = {
  x: window.pageXOffset,
  y: window.pageYOffset,
  percHeaderScrolled:20,
  windowHeight: 0
}

function getScrollPosition(){
  scrollObject.windowHeight = Number(window.innerHeight);
  
  scrollObject.x = window.pageXOffset;
  scrollObject.y = window.pageYOffset;

  //console.log(scrollObject);
  
  //header
  if(scrollObject.y >= (scrollObject.windowHeight * scrollObject.percHeaderScrolled / 100)){
    if(!$('header').hasClass('scrolled')){
      $('header').addClass('scrolled');
    }
    
  } else {
    $('header').removeClass('scrolled');
  }
  
  //hero banner
  if(scrollObject.y <= scrollObject.windowHeight){
    var perc = scrollObject.y / (scrollObject.windowHeight) * 1.8;
    var w_min = 100;
    var w_max = 150;

    var width = w_min + ((w_max - w_min) * perc);

    if(width > w_max){ width = w_max;}

    var left = (width - w_min) / 2;

    $(".agee-banner .banner__media img").css("max-width", "none");
    $(".agee-banner .banner__media img").css("width", width +"%");
    $(".agee-banner .banner__media img").css("left", "-" + left +"%");
  } else {
    $(".agee-banner .banner__media img").css("width", "100%");
  }
}


// --- HEADER --- //

function openMegaMenu(section){
  var btn = $("#btn-link-"+section);
  var mega = $("#mega-menu-"+section);

  if(mega.hasClass("open")){
    $(".main-menu-link").removeClass("active");
    $(".mega-menu").removeClass("open");
    return false;
  }

  $(".main-menu-link").removeClass("active");
  $(".mega-menu").removeClass("open");

  btn.addClass("active");
  mega.addClass("open");
}

//mobile
function openMobileMenu(){
  $(".open-menu").toggleClass("opened");
  $("#mobile-opened-menu").toggleClass("opened");

  if(!$("#mobile-opened-menu").hasClass("opened")){
    $(".mega-menu").removeClass("open");
  }
}

// Modal
$(".modal-toggle").on('click', function(e) {
  e.preventDefault();
  $(".modal").toggleClass("is-visible");
});
